import React from 'react';

const CrossSvg = ({ onClick }: { onClick: () => void }) => (
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28" cursor="pointer" onClick={onClick}>
    <path data-name="Path 68506" d="M0 0h28v28H0z" style={{fill:"none"}}/>
    <path data-name="Path 68507" d="M20.446 5.76a1.162 1.162 0 0 0-1.645 0l-5.7 5.692-5.7-5.7a1.163 1.163 0 0 0-1.652 1.641l5.7 5.7-5.7 5.7a1.163 1.163 0 1 0 1.645 1.645l5.7-5.7 5.7 5.7a1.163 1.163 0 1 0 1.652-1.638l-5.7-5.7 5.7-5.7a1.169 1.169 0 0 0 0-1.64z" transform="translate(.903 .903)" style={{fill:"#e31c25"}}/>
</svg>

);

export default CrossSvg;